import { BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { Weber } from "./magnetic-flux";
export var Henry = UnitDivide.magneticFluxByElectricalCurrent("Henry", Weber, BaseUnits.Ampere);
//# sourceMappingURL=electric-inductance.js.map